import { TOGGLE_STRUCTURE_FILTER_MENU } from './constants';

export function toggleStructureFilterMenu(value) {
  return {
    type: TOGGLE_STRUCTURE_FILTER_MENU,
    value,
  };
}
